/**
 * The resolved configuration type with all required fields populated.
 * This is the type returned by `_createConfig` and used internally.
 */

/**
 * Input configuration type that allows partial configs.
 * Users can provide any subset of the configuration, and defaults will be applied.
 * This is the type accepted by the LayoutManager constructor.
 */

export var defaultConfig = Object.freeze({
  openPopouts: [],
  settings: {
    hasHeaders: true,
    constrainDragToContainer: true,
    reorderEnabled: true,
    selectionEnabled: false,
    popoutWholeStack: false,
    blockedPopoutsThrowError: true,
    closePopoutsOnUnload: true,
    showPopoutIcon: true,
    showMaximiseIcon: true,
    showCloseIcon: true,
    responsiveMode: 'onload',
    // Can be onload, always, or none.
    tabOverlapAllowance: 0,
    // maximum pixel overlap per tab
    // reorderOnTabMenuClick: true, // Deephaven disabled
    tabControlOffset: 10
  },
  dimensions: {
    borderWidth: 5,
    borderGrabWidth: 10,
    minItemHeight: 10,
    minItemWidth: 10,
    headerHeight: 20,
    dragProxyWidth: 300,
    dragProxyHeight: 200
  },
  labels: {
    close: 'Close',
    maximise: 'Maximize',
    minimise: 'Minimize',
    popout: 'Open in new window',
    popin: 'Pop in',
    tabDropdown: 'Additional tabs',
    tabNextLabel: 'Next',
    tabPreviousLabel: 'Previous'
  },
  content: []
});
//# sourceMappingURL=Config.js.map